import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullFooterComponent } from './full-footer.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [FullFooterComponent],
  imports: [CommonModule, NgbTooltipModule],
  exports: [FullFooterComponent],
})
export class FullFooterModule {}
